// src/pages/contact.jsx
import React, { useState } from "react";
import Footer from "../components/footer";
import Hero from "../components/hero";
import ShapesBackground from "../components/shapesbackground";
import { useLang } from "../context/langcontext";
import emailjs from '@emailjs/browser';

const Contact = () => {
  const { t } = useLang();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const showSuccessPopup = (message) => {
    const popup = document.createElement('div');
    popup.className = 'custom-popup success-popup';
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-icon success-icon">✓</div>
        <h3>${t("successTitle") || "Success!"}</h3>
        <p>${message}</p>
        <button class="popup-btn" onclick="this.parentElement.parentElement.remove()">${t("closeBtn") || "Close"}</button>
      </div>
    `;
    document.body.appendChild(popup);
    setTimeout(() => popup.classList.add('show'), 10);
  };

  const showErrorPopup = (message) => {
    const popup = document.createElement('div');
    popup.className = 'custom-popup error-popup';
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-icon error-icon">✕</div>
        <h3>${t("errorTitle") || "Error"}</h3>
        <p>${message}</p>
        <button class="popup-btn" onclick="this.parentElement.parentElement.remove()">${t("closeBtn") || "Close"}</button>
      </div>
    `;
    document.body.appendChild(popup);
    setTimeout(() => popup.classList.add('show'), 10);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const serviceID = 'service_6juzkg8';
      const templateID = 'template_dfrkf5p';
      const publicKey = '9fxVTVWsjvliV6c0h';

      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
        to_email: 'info@selalom.com',
      };

      await emailjs.send(
        serviceID,
        templateID,
        templateParams,
        publicKey
      );

      showSuccessPopup(t("messageSent") || "Your message has been sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error sending email:", error);
      showErrorPopup(t("messageError") || "Failed to send message. Please try again or contact us directly at info@selalom.com");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ShapesBackground />
      
      <Hero
        heroImage={require('../assets/phone/contact.png')}
        customHeading={t("contactTitle")}
        customSubtext={t("contactCustomSubtext")}
        customDescription={t("contactHeroDescription")}
        hideButtons={["contact"]}
      />
      
      <section className="contact-section">
        <div className="contact-form">
          <h2>{t("contactFormTitle") || "We'd Love to Hear from You"}</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder={t("contactName") || "Your Name"}
              value={formData.name}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            <input
              type="email"
              name="email"
              placeholder={t("contactEmail") || "Your Email"}
              value={formData.email}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            <textarea
              name="message"
              placeholder={t("contactMessage") || "Your Message"}
              value={formData.message}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? (t("sending") || "Sending...") : (t("contactSend") || "Send Message")}
            </button>
          </form>
        </div>
        
        <div className="contact-info">
          <h2>{t("contactInfoTitle") || "Contact Info"}</h2>
          <ul>
            <li>
              <span>{t("contactEmailLabel") || "Email:"}</span> info@selalom.com
            </li>
            <li>
              <span>{t("contactPhoneLabel") || "Phone:"}</span> ‪‪+968 9826 4142‬‬ | ‪‪+968 9283 6103‬‬
            </li>
            <li>
              <span>{t("contactInstagramLabel") || "Instagram:"}</span> @selal_aap
            </li>
          </ul>
        </div>
      </section>
      
      <Footer />
    </>
  );
};

export default Contact;